export interface TerminateSearchAgentApiRequest {
    task_id: string;
}

export type TerminateSearchAgentApiResponse = void;

/**
 * 终止搜索 API
 */
export interface TerminateSearchAgentApi {
    /**
     * 发送终止搜索请求的请求
     * @param request 请求参数
     * @returns 响应
     */
    terminateSearchAgent(request: TerminateSearchAgentApiRequest): Promise<TerminateSearchAgentApiResponse>;
}

export const TerminateSearchAgentApi = Symbol.for('TerminateSearchAgentApi');
